// extracted by mini-css-extract-plugin
export var chevronIcon = "_bf-2";
export var teamName = "_bf-1";
export var teamSwitcherButton = "_bf-0";